import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
Alert.displayName = 'Alert';

interface NotificationProps {
  open: boolean;
  message: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
  duration?: number;
  onClose?: () => void;
}

const SnackBar: React.FC<NotificationProps> = ({
  open,
  message,
  severity = 'info',
  duration = 3000,
  onClose,
}) => (
  <Snackbar open={open} autoHideDuration={duration} onClose={onClose}>
    <Alert severity={severity} onClose={onClose} sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);

export default SnackBar;
